import { Info, ReportProblem } from "@mui/icons-material";
import { Chip, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import type React from "react";
import { useEffect } from "react";
import useDetail from "../../../hooks/useDetail.ts";
import { calculateDateInfo } from "./countDown.ts";

interface CountDownProps {
	now: DateTime;
	oneWeekBefore: DateTime;
	twoWeeksBefore: DateTime;
	date: DateTime;
}

const CountDown: React.FC<CountDownProps> = ({ now, twoWeeksBefore, oneWeekBefore, date }) => {
	const theme = useTheme();
	const { color, timeLeftText } = calculateDateInfo(date.toISO() || "", "toDate", theme);
	useEffect(() => {
		if (timeLeftText !== "Neplatné datum" && timeLeftText !== "Bez omezení konce platnosti") {
			const intervalId = setInterval(() => {
				calculateDateInfo(date.toISO() ?? "", "toDate", theme);
			}, 1000);
			return () => clearInterval(intervalId);
		}
	}, [date, timeLeftText, theme]);

	const icon =
		now > twoWeeksBefore && now < oneWeekBefore ? (
			<Info sx={{ paddingLeft: "0.3rem" }} color="inherit" />
		) : (
			<ReportProblem sx={{ paddingLeft: "0.3rem" }} color="inherit" />
		);

	return <Chip label={timeLeftText} size="small" sx={{ color: "white", backgroundColor: color }} icon={icon} />;
};

const CountdownChip: React.FC<{ id: number }> = ({ id }) => {
	const detail = useDetail(id);

	const validTo = detail.data.publishTo;

	if (!validTo) {
		return null;
	}

	const dateTime = DateTime.fromISO(validTo).isValid ? DateTime.fromISO(validTo) : undefined;

	if (!dateTime) {
		return null;
	}

	const now = DateTime.now();
	const oneWeekBefore = dateTime.minus({ weeks: 1 });
	const twoWeeksBefore = dateTime.minus({ weeks: 2 });

	const validDateTime = now > twoWeeksBefore && now < dateTime;

	if (!validDateTime) {
		return null;
	}

	return <CountDown date={dateTime} oneWeekBefore={oneWeekBefore} now={now} twoWeeksBefore={twoWeeksBefore} />;
};

export default CountdownChip;
